import { getMessageParts } from '@ai-sdk/ui-utils';
/**
 * Text to persist and compare for MobX sync. The AI SDK often keeps `message.content`
 * empty while streaming text into `parts` ({ type: 'text', text }); only syncing `content`
 * yields blank assistant bubbles after loading finishes.
 */
export function getChatMessageTextForSync(msg) {
    const raw = typeof msg.content === 'string' ? msg.content : '';
    if (raw.trim().length > 0) {
        return raw;
    }
    if (msg.role !== 'assistant') {
        return raw;
    }
    // getMessageParts returns `message.parts` as-is when set; an empty array skips the
    // fallback that would rebuild from `content` + toolInvocations. Strip empty `parts`
    // so text can still be derived from `content` / legacy fields.
    const msgAny = msg;
    const forParts = Array.isArray(msgAny.parts) && msgAny.parts.length === 0
        ? { ...msg, parts: undefined }
        : msg;
    const parts = getMessageParts(forParts);
    const texts = [];
    for (const part of parts) {
        if (part.type === 'text' && typeof part.text === 'string') {
            texts.push(part.text);
        }
    }
    return texts.join('');
}
//# sourceMappingURL=getChatMessageTextForSync.js.map